import {combineReducers} from 'redux'
import summary from './summary'
import translations from '../../booking_engine/reducers/translations'

export default combineReducers({
    summary,
    translations
})
